/* Numbers */
export const ID_MAX_LEN = 50;

/* Booleans */
export const ENABLE_CATEGORIZATION = false;